module.exports = __webpack_public_path__ + "img/Overlay (2).d2d21816.png";